const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-2 text-white/50 text-[12px] tracking-[0.25em] uppercase">
    <span className="w-1.5 h-1.5 rounded-full bg-[#2f6bff]" /> {children}
  </div>
);

export default SectionLabel;
